import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { AbstractModel, isNullOrUndefined, DistanceUtil } from '@uzurv/core';
import { LyftDispatchRideStatus } from './lyft-dispatch-ride-status';
import { LyftDispatchRideType } from './lyft-dispatch-ride-type';

@inheritSerialization(AbstractModel)
export class LyftDispatchRide extends AbstractModel {
  @autoserialize
  rideRequestId: number;

  @autoserialize
  reservationId: number;

  @autoserialize
  lyftRideIdentifier: string;

  @autoserializeAs(LyftDispatchRideType)
  lyftDispatchRideType: LyftDispatchRideType;

  @autoserializeAs(LyftDispatchRideStatus)
  lyftDispatchRideStatus: LyftDispatchRideStatus;

  @autoserialize
  routeUrl: string;

  @autoserialize
  driverMessage: string;

  @autoserialize
  externalNotes: string;

  @autoserialize
  primetimePercentage: number;

  @autoserialize
  beaconColor: string;

  @autoserialize
  vehicleColor: string;

  @autoserialize
  vehicleMake: string;

  @autoserialize
  vehicleModel: string;

  @autoserialize
  vehicleYear: string;

  @autoserialize
  vehicleLicenseState: string;

  @autoserialize
  vehicleLicensePlate: string;

  @autoserialize
  vehicleImageUrl: string;

  @autoserialize
  driverName: string;

  @autoserialize
  driverPhoneNumber: string;

  @autoserialize
  driverAvatarUrl: string;

  @autoserializeAs(Date)
  requestedAt: Date;

  @autoserializeAs(Date)
  generatedAt: Date;

  @autoserializeAs(Date)
  statusSyncedDate: Date;

  @autoserialize
  distance: number;

  @autoserialize
  duration: number;

  @autoserialize
  createdByUserId: number;

  @autoserialize
  cancelledBy: string;

  @autoserialize
  fareReviewStatusId: number;

  durationInMinutes: number;

  static OnDeserialized(instance: LyftDispatchRide, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['distance'])) {
      instance.distance = DistanceUtil.convertMetersToMiles(instance.distance, 2);
    }

    if (!isNullOrUndefined(json['duration'])) {
      instance.durationInMinutes = +(instance.duration / 60).toFixed(2);
    }
  }
}
